import React, { useState } from "react";
import { useFormValidation, TextInput, PasswordInput, PrimaryButton } from "../common";
import { Checkbox, FormControlLabel, Paper } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { post, handleResponse, swal500, handle400 } from "../../utils/network";
import validateUser from '../Users/UsersForm/validator';

const FIELDS = {
  firstName: "Nombre",
  lastName: "Apellido",
  email: "Email",
  password: "Contraseña",
  isAdmin: "Es administrador",
  serviceUser: "Usuario de servicio",
  groups: "Grupos de accesso (ingresar los valores separados por ',')",
};

const INITIAL_STATE = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  isAdmin: false,
  serviceUser: false,
  groups: "",
};


export default function AddUser() {
  const history = useHistory();
  const isMountedRef = React.useRef(true);

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values = INITIAL_STATE,
    errors,
    setErrors,
    resetValues
  } = useFormValidation(INITIAL_STATE, v => validateUser(v, true));

  const [submitting, setSubmitting] = useState(false);

  React.useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleFormSubmit = (e) => {
    e.preventDefault();

    setSubmitting(true);

    const { password, email, firstName, lastName, groups } = values;

    const body = {
      password,
      email,
      firstName,
      lastName,
      isAdmin: values.isAdmin,
      isServiceUser: values.serviceUser,
      groups: groups.length > 0 ? groups.split(',').map(group => group.trim()) : []
    };

    post('dev/users', body, false)
      .then(res =>
        handleResponse(res, { history }, [
          { status: 400, method: handle400(FIELDS, setErrors) },
        ])
      )
      .then(() => {
        if (!isMountedRef.current) return;
        
        resetValues(INITIAL_STATE);
        history.push('/dev', { msg: 'Usuario creado exitosamente' });
      })
      .catch(err => {
        if (!isMountedRef.current) return;
        if (err !== 400) swal500(err);
      })
      .finally(() => {
        if (isMountedRef.current) {
          setSubmitting(false);
        }
      });
  };

  return (
    <div style={{ padding: 20, maxWidth: 600, margin: '0 auto' }}>
      <h2 style={{ marginBottom: 20 }}>Crear Usuario</h2>

      <Paper style={{ boxShadow: '0 8px 16px 0 rgb(0 0 0 / 10%)', padding: '24px' }}>
        <form 
          onSubmit={handleFormSubmit}
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
          }}
        >
            <TextInput
              name="firstName"
              value={values.firstName}
              error={errors.firstName}
              handleChange={handleChange}
              handleBlur={handleBlur}
              label={FIELDS.firstName}
            />

            <TextInput
              name="lastName"
              value={values.lastName}
              error={errors.lastName}
              handleChange={handleChange}
              handleBlur={handleBlur}
              label={FIELDS.lastName}
            />

            <TextInput
              name="email"
              value={values.email}
              error={errors.email}
              handleChange={handleChange}
              handleBlur={handleBlur}
              label={FIELDS.email}
            />

            <PasswordInput
              name="password"
              value={values.password}
              error={errors.password}
              handleChange={handleChange}
              onBlur={handleBlur}
              label={FIELDS.password}
              hideStartAdornment
              InputProps={{ autoComplete: 'new-password' }}
            />

            <TextInput
              name="groups"
              value={values.groups}
              error={errors.groups}
              handleChange={handleChange}
              handleBlur={handleBlur}
              label={FIELDS.groups}
            />

          <div style={{ marginTop: 8, marginBottom: 8 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={values.isAdmin}
                  onChange={e =>
                    handleChange({
                      target: { name: 'isAdmin', value: e.target.checked }
                    })
                  }
                />
              }
              label={FIELDS.isAdmin}
            />
          </div>

          <div style={{ marginTop: 8, marginBottom: 8 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={values.serviceUser}
                  onChange={e =>
                    handleChange({
                      target: { name: 'serviceUser', value: e.target.checked }
                    })
                  }
                />
              }
              label={FIELDS.serviceUser}
            />
          </div>

          <div style={{ marginTop: 30, textAlign: 'right', width: '100%' }}>
            <PrimaryButton type="submit" disabled={submitting}>
              {submitting ? 'Creando...' : 'Crear Usuario'}
            </PrimaryButton>
          </div>
        </form>
      </Paper>
    </div>
  );
}
